<template>
  <div v-if="meetingInfo">
    <b-steps v-model="stage" @input="routing" size="is-small" type="is-primary" :has-navigation="false">
      <b-step-item :clickable="true" value="/meetings/attendee-details" label="Attendee Details" icon="account-key"></b-step-item>

      <b-step-item :clickable="profileSubmitted" value="/meetings/survey"  label="Survey" icon="account" v-if="meetingInfo.meeting.survey"></b-step-item>

      <b-step-item :clickable="profileSubmitted && surveyCompleted && !meetingInfo.pnrRecordLocator" value="/meetings/flights" v-if="meetingInfo.meeting.useFlightTool" label="Flight" icon="airplane" />

      <b-step-item :clickable="profileSubmitted && surveyCompleted && !meetingInfo.pnrRecordLocator" value="/meetings/hotels" v-if="meetingInfo.meeting.useHotelTool" label="Hotel" icon="bed" />

      <b-step-item :clickable="profileSubmitted && surveyCompleted && !meetingInfo.pnrRecordLocator" value="/meetings/cars"  v-if="meetingInfo.meeting.useCarTool" label="Car" icon="car" />

      <b-step-item :clickable="(result.flight.journeys || meetingInfo.noAirTravelRequired) && (result.car.pickupInfo) && (result.hotel.hotelCode)" value="/meetings/summary"
                   @click="routing('/summary')" label="Checkout" icon="cart"></b-step-item>
    </b-steps>
  </div>
</template>

<script>
import meetingsMixin from "@/mixins/meetingsMixin";
  export default {
    name: 'MeetingSteps',
    mixins: [meetingsMixin],
    data: function () {
      return {
        stage: '',
        routeConversions: {
          "/meetings": "/meetings/attendee-details",
          "/meetings/attendee-details": "/meetings/attendee-details",
          "/meetings/survey": "/meetings/survey",
          "/meetings/flights": "/meetings/flights",
          "/meetings/flights-results": "/meetings/flights",
          "/meetings/cars": "/meetings/cars",
          "/meetings/cars-results": "/meetings/cars",
          "/meetings/hotels": "/meetings/hotels",
          "/meetings/hotels-results": "/meetings/hotels",
          "/meetings/summary": "/meetings/summary",
          "/meetings/confirmation": "/meetings/summary"
        },
        changedFromRoute: false
      }
    },
    props: {
    },
    watch:{
      $route (to, from){
        //console.log(this.stage)
        //console.log(to)
        if (this.stage != this.routeConversions[to.path]){
          this.changedFromRoute = true
          this.stage = this.routeConversions[to.path]
        }
      }
    },
    methods: {
      routing(path){
        // console.log(path)
        this.$router.push({ path: path  })
      }
    },
    computed: {
      result(){
        return this.$store.state.bookTravel.result
      },
      surveyCompleted(){
        return this.$store.state.meetings.meetingSurveySet;
      },
      profileSubmitted(){
        return this.$store.state.meetings.meetingProfileSet;
      }
    },
    mounted () {
      // if (this.stage != this.routeConversions[this.$route.path]){
      this.changedFromRoute = true
      this.stage = this.routeConversions[this.$route.path];
      // }
    },
}
</script>

<style lang="scss" scoped>
  // mobile
  @media screen and (max-width: 1023px) {

    .profile {
      margin: auto;

    }

  }
  // pc
  @media screen and (min-width: 1024px) {

    .profile {
      margin: auto;
    }

  }
</style>
